<template>
    <b-row>
        <b-col cols="6">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="mb-3">
                        <div class="">
                            <b-row>
                                <b-col sm="12" class="pb-2">
                                    <h4>Formulario de creación de usuario</h4>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group label="Nombre" label-for="account-username">
                                        <b-form-input v-model="name" placeholder="Inserte el nombre aquí"
                                                      :class="validation.name ? 'is-invalid': ''"/>
                                        <small v-if="validation.name" class="text-danger"> {{ validation.name }}</small>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Correo electrónico" label-for="account-email">
                                        <b-form-input v-model="email" placeholder="Email"
                                                      :class="validation.email ? 'is-invalid': ''"/>
                                        <small v-if="validation.email" class="text-danger"> {{
                                                validation.email
                                            }}</small>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group label="Contraseña" label-for="account-password">
                                        <b-form-input v-model="password" placeholder="Contraseña" type="password"
                                                      autocomplete="off"
                                                      :class="validation.password ? 'is-invalid': ''"/>
                                        <small v-if="validation.password" class="text-danger"> {{
                                                validation.password
                                            }}</small>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Confirmar constraseña"
                                                  label-for="account-password-confirmation">
                                        <b-form-input v-model="password_confirmation" type="password"
                                                      placeholder="Confirmación de contraseña"/>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group label="Seleccionar permisos del usuario" label-for="account-roles">
                                        <b-form-checkbox
                                            v-for="role in roles"
                                            :key="role.id"
                                            v-model="selectedRole"
                                            :value="role.id"
                                            class="mt-1"
                                        >
                                            {{ role.display_name }}
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Visualización de la barra de navegación"
                                                  label-for="account-permissions">
                                        <b-form-checkbox
                                            v-for="permission in permissions"
                                            :key="permission.id"
                                            v-model="selectedPermissions"
                                            :value="permission.id"
                                            class="mt-1"
                                        >
                                            {{ permission.display_name }}
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row v-if="platform!='VHE'">
                                <b-col sm="5">
                                    <b-form-group label="Empresa/s" label-for="account-companies">
                                        <v-select
                                            v-model="selectedCompanies"
                                            label="name"
                                            type="type"
                                            :reduce="(option) => option.id"
                                            :options="companies"
                                            multiple
                                        >
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>


                        <b-row align-h="start">
                            <b-col cols="5">
                                <b-button v-if="!edit" variant="primary" class="mt-2 mr-1" @click="sendData">
                                    Guardar cambios
                                </b-button>
                                <b-button v-else variant="primary" class="mt-2 mr-1" @click="updateData">
                                    Actualizar cambios
                                </b-button>
                                <b-button variant="outline-secondary" type="reset" class="mt-2" @click="cancel">
                                    Cancelar
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import vSelect from "vue-select"
import {BButton, BCard, BCol, BFormGroup, BFormInput, BOverlay, BRow, BFormCheckbox} from 'bootstrap-vue'
import {platforms} from "@/constants/platforms"
import {mapState} from "vuex"
import {USER_LIST} from "@/router/web/constants"
import ToastificationContent from "@core/components/toastification/ToastificationContent"
import {fillablePermissions, fillablePermissionsVHE} from "@/constants/permissions"
import authService from "@/services/auth/authService"

export default {
    name: "FormView",
    components: {
        vSelect,
        BCol,
        BRow,
        BButton,
        BFormGroup,
        BFormInput,
        BCard,
        BOverlay,
        BFormCheckbox,
    },
    data() {
        return {
            edit: false,

            name: null,
            email: null,
            password: null,
            password_confirmation: null,

            showLoading: false,

            selectedCompanies: [],
            companies: [],
            selectedRole: 3, // Sólo lectura por defecto
            roles: [
                {id: 2, display_name: 'Lectura/Escritura'},
                {id: 3, display_name: 'Sólo lectura'},
            ],
            selectedPermissions: [],
        }
    },
    computed: {
        platform() {
            return authService.activePlatform()
        },
        permissions() {
            if (authService.activePlatform()=='VHE')
                return fillablePermissionsVHE
            else
                return fillablePermissions
        },
        ...mapState('user', ['validation']),
    },
    created() {
        this.getCompanies()

        this.$store.commit('user/CLEAR_VALIDATION')

        if (this.$route.params.id) {
            this.edit = true
            this.getUser()
        } else {
            this.edit = false
        }
    },
    methods: {
        getCompanies() {
            this.$store.dispatch('companies/getAllCompanies')
                .then(response => {
                    this.companies = response
                })
                .catch(error => {
                    console.log(error)
                })
        },
        sendData() {
            this.$store.dispatch('user/createUser', {
                name: this.name,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                companies: this.selectedCompanies,
                role: this.selectedRole,
                permissions: this.selectedPermissions,
            })
                .then(response => {
                    this.$router.replace(USER_LIST)
                        .then(() => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `¡Usuario creado correctamente!`,
                                    icon: 'CheckIcon',
                                    variant: 'success',
                                },
                            })
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateData() {
            this.$store.dispatch('user/updateUser', {
                id: this.$route.params.id,
                name: this.name,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                permissions: this.selectedPermissions,
                companies: this.selectedCompanies,
                role: this.selectedRole,
            })
                .then(response => {
                    this.$router.replace(USER_LIST)
                        .then(() => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: `¡Usuario actualizado correctamente!`,
                                    icon: 'CheckIcon',
                                    variant: 'success',
                                },
                            })
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getUser() {
            this.showLoading = true

            this.$store.dispatch('user/getUser', {
                relations: ['roles', 'companies', 'permissions'],
                id: this.$route.params.id,
            })
                .then(response => {
                    this.name = response.name
                    this.email = response.email
                    this.selectedRole = response.roles[0].id
                    this.selectedPermissions = response.permissions.map(function (permission) {
                        return permission['id']
                    })
                    this.selectedCompanies = response.companies.map(function (company) {
                        return company['id']
                    })

                    this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(USER_LIST)
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>